<template>
  <div>
    <div class="manage-control" v-if="!isMember()">
      <mode-switcher v-if="!isMember() && isExpanded"></mode-switcher>
      <selected-member
        v-if="userMode == 'MENTOR' && isExpanded"
      ></selected-member>
    </div>
    <member-navbar v-if="isMember()" :isExpanded="isExpanded"></member-navbar>
    <manager-navbar
      v-else-if="userMode == 'MANAGE'"
      :isExpanded="isExpanded"
    ></manager-navbar>
    <mentor-navbar
      v-else-if="userMode == 'MENTOR'"
      :isExpanded="isExpanded"
    ></mentor-navbar>
  </div>
</template>

<script>
import ManagerNavbar from "@/containers/navigations/NavigationBarManager"
import MemberNavbar from "@/containers/navigations/NavigationBarMember"
import MentorNavbar from "@/containers/navigations/NavigationBarMentor"
import ModeSwitcher from "@/containers/navigations/ModeSwitcher"
import SelectedMember from "@/containers/navigations/SelectedMember"
import userMixin from "@/mixins/userMixin"

import { mapGetters } from "vuex"

export default {
  mixins: [userMixin],
  components: {
    ManagerNavbar,
    MemberNavbar,
    MentorNavbar,
    ModeSwitcher,
    SelectedMember
  },
  props: {
    isExpanded: { type: Boolean, default: true }
  },
  computed: {
    ...mapGetters("globals", { userMode: "getUserMode" })
  }
}
</script>

<style lang="scss" scoped>
.manage-control {
  height: 100px;
}
</style>
